import React from 'react';
import { Link } from 'react-router-dom';

function Navbar({ scrolled }) {
  return (
    <nav className={`navbar navbar-expand-lg fixed-top ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        
        {/* LOGO + TEXT */}
        <Link to="/" className="navbar-brand">
          <img 
            src="/images/logo.png" 
            alt="BARQ ALWUSOOL" 
            className="navbar-logo"
          />
          <span className="navbar-text">BARQ ALWUSOOL</span>
        </Link>

        {/* MOBILE MENU TOGGLE */}
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon">☰</span>
        </button>

        {/* MENU ITEMS */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/services">Services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/fleet">Fleet</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact</Link>
            </li>
            <li className="nav-item ms-3">
              <Link to="/contact">
                <button className="btn btn-gold">Get a Quote</button>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;